import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import "components/PreferredCommunicationChannel/PreferredCommunicationChannel.scss";
import { COMMUNICATION_CHANNELS } from "models";

type PreferredCommunicationChannelProps = {
  channel?: COMMUNICATION_CHANNELS;
};

export const PreferredCommunicationChannel = ({ channel }: PreferredCommunicationChannelProps) => {
  const { t } = useTranslation();

  switch (channel) {
    case COMMUNICATION_CHANNELS.Email:
      return (
        <span className="PreferredCommunicationChannel">
          <Icon name="mail outline" />
          <span>{t("v8_email", "Email")}</span>
        </span>
      );

    case COMMUNICATION_CHANNELS.SMS:
      return (
        <span className="PreferredCommunicationChannel">
          <Icon name="mobile alternate" />
          <span>{t("v8_sms", "SMS")}</span>
        </span>
      );

    case COMMUNICATION_CHANNELS.WhatsApp:
      return (
        <span className="PreferredCommunicationChannel">
          <Icon className="whatsapp brand" />
          <span>WhatsApp</span>
        </span>
      );

    default:
      return null;
  }
};
